import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import CuentaBancaria from './cuentaBancaria';
import ACCESS from '../../../ACCESS.js';

class CuentasBancarias extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cuenta-bancaria/filter', deleteUrl: 'cuenta-bancaria/delete', deleteField: 'cuenta_nombre', modUrl: '/Catalogo/CuentaBancaria' },
      TableOp.Table('Cuentas Bancarias', [
        { label: 'Cuenta', id: 'cuenta' },
        { label: 'Numero de Cuenta', id: 'cuenta_no' },
        { label: 'Descripcion', id: 'cuenta_nombre' },
        { label: 'Ccont', id: 'cuenta_ccont' },
        { label: 'RFC', id: 'cuenta_rfc' },
        { label: 'Banco', id: 'banco' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CUENTAS_BANCARIAS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_CUENTAS_BANCARIAS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <CuentaBancaria  onSave={() => { this.table() }}></CuentaBancaria>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(CuentasBancarias)